var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3031_2139)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z",
    fill: "url(#paint0_linear_3031_2139)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4072 46.2986C38.4072 49.0058 40.6021 51.2006 43.3092 51.2006C46.0164 51.2006 48.2112 49.0058 48.2112 46.2986C48.2112 43.5915 46.0164 41.3966 43.3092 41.3966C40.6021 41.3966 38.4072 43.5915 38.4072 46.2986Z",
    fill: "#F5DE5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4746 46.2986C22.4746 49.0058 24.6695 51.2006 27.3766 51.2006C30.0837 51.2006 32.2786 49.0058 32.2786 46.2986C32.2786 43.5915 30.0837 41.3966 27.3766 41.3966C24.6695 41.3966 22.4746 43.5915 22.4746 46.2986Z",
    fill: "#F5DE5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3087 42.0087C45.6733 42.0087 47.5979 43.9334 47.5979 46.298C47.5979 48.6627 45.6733 50.5873 43.3087 50.5873C40.944 50.5873 39.0194 48.6627 39.0194 46.298C39.0194 43.9334 40.944 42.0087 43.3087 42.0087ZM43.3087 51.8128C46.3498 51.8128 48.8234 49.3391 48.8234 46.298C48.8234 43.2569 46.3498 40.7832 43.3087 40.7832C40.2676 40.7832 37.7939 43.2569 37.7939 46.298C37.7939 49.3391 40.2676 51.8128 43.3087 51.8128Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3094 45.0724C43.9853 45.0724 44.5349 45.6221 44.5349 46.2979C44.5349 46.9738 43.9853 47.5234 43.3094 47.5234C42.6336 47.5234 42.0839 46.9738 42.0839 46.2979C42.0839 45.6221 42.6336 45.0724 43.3094 45.0724ZM43.3094 48.7489C44.6612 48.7489 45.7604 47.6497 45.7604 46.2979C45.7604 44.9462 44.6612 43.8469 43.3094 43.8469C41.9577 43.8469 40.8584 44.9462 40.8584 46.2979C40.8584 47.6497 41.9577 48.7489 43.3094 48.7489Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3781 42.0087C29.7427 42.0087 31.6674 43.9334 31.6674 46.298C31.6674 48.6627 29.7427 50.5873 27.3781 50.5873C25.0135 50.5873 23.0888 48.6627 23.0888 46.298C23.0888 43.9334 25.0135 42.0087 27.3781 42.0087ZM27.3781 51.8128C30.4192 51.8128 32.8929 49.3391 32.8929 46.298C32.8929 43.2569 30.4192 40.7832 27.3781 40.7832C24.337 40.7832 21.8633 43.2569 21.8633 46.298C21.8633 49.3391 24.337 51.8128 27.3781 51.8128Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3758 45.0724C28.0517 45.0724 28.6013 45.6221 28.6013 46.2979C28.6013 46.9738 28.0517 47.5234 27.3758 47.5234C26.7 47.5234 26.1503 46.9738 26.1503 46.2979C26.1503 45.6221 26.7 45.0724 27.3758 45.0724ZM27.3758 48.7489C28.7276 48.7489 29.8268 47.6497 29.8268 46.2979C29.8268 44.9462 28.7276 43.8469 27.3758 43.8469C26.0241 43.8469 24.9248 44.9462 24.9248 46.2979C24.9248 47.6497 26.0241 48.7489 27.3758 48.7489Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0255 48.1368H20.6394V46.9112H20.0255C19.6879 46.9112 19.4127 46.6386 19.4127 46.3028C19.4103 43.4155 19.4048 36.0735 19.4066 31.5894C19.4066 29.9019 20.7797 28.5286 22.4666 28.5286H42.1164C42.927 28.5286 43.6318 29.0501 43.8708 29.8259L45.9076 36.4467L49.6416 36.8615C50.5742 36.9651 51.2771 37.7506 51.2771 38.6881V46.2985C51.2771 46.6367 51.0025 46.9112 50.6643 46.9112H50.0515V48.1368H50.6643C51.6778 48.1368 52.5025 47.312 52.5025 46.2985V38.6881C52.5025 37.1249 51.331 35.8161 49.7771 35.6428L46.8426 35.3167L45.0424 29.4655C44.6441 28.172 43.4681 27.3031 42.1164 27.3031H22.4666C20.1038 27.3031 18.1811 29.226 18.1811 31.5894C18.1792 36.0735 18.1848 43.4167 18.1872 46.304C18.1878 47.3144 19.0132 48.1368 20.0255 48.1368Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1152 48.1368H38.4054V46.9111H34.1152V48.1368Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2773 45.6861H38.4049V44.4607H32.2773V45.6861Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8613 46.2979H23.0868V32.8173C23.0868 32.4791 23.3613 32.2046 23.6996 32.2046H41.5969L43.8334 41.7115L45.027 41.4303L42.7899 31.9234C42.6581 31.3676 42.1686 30.9791 41.5969 30.9791H23.6996C22.6861 30.9791 21.8613 31.8038 21.8613 32.8173V46.2979Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.209 45.6861H51.8862V44.4604H48.209V45.6861Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7969 45.6861H20.6355V44.4604H18.7969V45.6861Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4736 37.107H43.3072V35.8815H22.4736V37.107Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2793 36.4944H33.5048V31.5924H32.2793V36.4944Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7314 36.4944H35.9569V31.5924H34.7314V36.4944Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5049 43.234H34.7304V36.4937H33.5049V43.234Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.935 16.9335C42.8823 16.9335 43.6532 17.614 43.6532 18.4502V22.4946C43.6532 23.3308 42.8823 24.0113 41.935 24.0113H22.4623C21.515 24.0113 20.7441 23.3308 20.7441 22.4946V18.4502C20.7441 17.614 21.515 16.9335 22.4623 16.9335H41.935ZM22.4623 25.0225H41.935C43.514 25.0225 44.7986 23.8885 44.7986 22.4946V18.4502C44.7986 17.0564 43.514 15.9225 41.935 15.9225H22.4623C20.8833 15.9225 19.5986 17.0564 19.5986 18.4502V22.4946C19.5986 23.8885 20.8833 25.0225 22.4623 25.0225Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6016 24.2394H29.8271V16.5394H28.6016V24.2394Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1523 24.2394H27.3778V16.5394H26.1523V24.2394Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9561 24.2394H37.1816V16.5394H35.9561V24.2394Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4062 24.2394H39.6318V16.5394H38.4062V24.2394Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3031_2139",
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A6A6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3031_2139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.87a0a32e077db19454b498b28f4510b8.svg";
export { ForwardRef as ReactComponent };